module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ar":{"new_item":"تسجيل منتج جديد","itemlines":"منتجات"},"he":{"add_new_order":"הוספת הזמנה חדשה"}}')
  delete Component.options._Ctor
}
